import { useState } from 'react';
import { Collapse } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const TomorrowAlert = ({ recipeNotesForNextDay }) => {
  const { t } = useTranslator();
  const [collapse, setCollapse] = useState(false);
  const {
    images: { tomorrowAlertIcon },
    svgInline: { DownArrow },
  } = useAppContext();

  let tomorrowAlert = [];

  if (recipeNotesForNextDay && Object.keys(recipeNotesForNextDay).length !== 0) {
    tomorrowAlert = [...recipeNotesForNextDay];
  }

  const uniqTomorrowAlert = [...new Set(tomorrowAlert)];

  if (uniqTomorrowAlert.length > 0) {
    return (
      <div className="tomorrow-alert">
        <h3 onClick={() => setCollapse(!collapse)}>
          <img src={tomorrowAlertIcon} style={{ width: '24px' }} className="me-s" alt="" />
          {t('mealDetails.prepareForTomorrow.title')}
          <span className={collapse ? 'collapse-arrow open' : 'collapse-arrow'}>
            <span className="SVGInline">
              <DownArrow />
            </span>
          </span>
        </h3>
        <Collapse isOpen={collapse}>
          <ul>
            {uniqTomorrowAlert.map((alert, idx, arr) => (
              <li key={arr.indexOf(alert)}>{alert}</li>
            ))}
          </ul>
        </Collapse>
      </div>
    );
  }

  return '';
};

export default TomorrowAlert;
